import React from "react";
import {connect} from "react-redux";

import LookListFeature from "../../lookNavigation/lookMain/lookListFeature/lookListFeature";
import LookWizardSectionListFeature from "../../lookNavigation/lookMain/lookWizard/lookWizardSectionListFeature";
import {getCurrentGroups} from "../../lookNavigation/lookMain/lookWizard/lookWizardFunctions";

const preventRequiredFunc = () => {};

const LookAllWallsTutorialHighlightFeature = (props) => {

  const {lookAllWallsTutorial, wizardActiveItem, wizardActiveStep, wizardSelectedValues} = props;
  const {left, top, height, width, lookFeature} = lookAllWallsTutorial;

  let style = {
    position: "fixed",
    left,
    top,
    height,
    width,
    textAlign: "left",
  }

  if (wizardActiveItem) {

    const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
    const wizardGroup = currentGroups[0];

    return <LookWizardSectionListFeature lookFeature={lookFeature}
                                         wizardGroup={wizardGroup}
                                         imageCanvas={{}}
                                         isAllWallsTutorialItem={true}
                                         updateLookCartItem={preventRequiredFunc}
                                         maxClickCountReached={preventRequiredFunc}
                                         style={style}
                                         navItems={[]}/>
  }

  return <LookListFeature style={style}
                          isAllWallsTutorialItem={true}
                          lookFeature={lookFeature}
                          navItems={[]}/>
};

const mapStateToProps = (store) => {
  const {lookAllWallsTutorial, lookViewType} = store.lookState;
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues} = store.wizardState;
  const {isMobile} = store.serverState;
  return {
    lookAllWallsTutorial,
    lookViewType,
    isMobile,
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
  };
};

export default (
  connect(mapStateToProps)(LookAllWallsTutorialHighlightFeature)
)
